function Resources({ data }) {
    return (
        <div key={data.documentId} className="resources">
            <div className="row background-full-width resource-div" style={{margin: '0 auto', maxWidth: '1270px'}}>
                {data.resourceSectionBlocks.map((item, index) => (
                    <div className="col-md-4 col-sm-12 col-xs-12">
                        {/*no resource item means our first block which will lack a link and have a different background/text color*/}
                        <div className={"container resource-container no-padding ".concat(item.resource == null ? 'first-block' : 'light-blue-background white-text')}>
                            <div className="container resource-block">
                                <p className={'section-headline-small '.concat(item.resource == null ? 'light-blue-text' : 'white-text')}>
                                    {item.title}
                                </p>
                                {item.resource == null ?
                                    // no resource item means our first block which will lack a link
                                    <div>
                                        <p className="body-text"></p>
                                        <p>{item.paragraph}</p>
                                        <p></p>
                                    </div>
                                    // else
                                    :
                                    <div>
                                        <p className="resources-box-text">
                                            {item.paragraph}
                                        </p>

                                        <a className="white-text resource-link"
                                           href={item.resource.url}>
                                            <strong>{item.resource.label}</strong>
                                            <img className="filter-white" style={{height: '15px', width: '30px'}}
                                                 src={item.resource.image.url}/>
                                        </a>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Resources;
